"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthConfirmSignUp = void 0;
var React = require("react");
function AuthConfirmSignUp(_a) {
    var authState = _a.authState, Components = _a.Components;
    if (['confirmSignUp'].indexOf(authState) < 0) {
        return null;
    }
    return (React.createElement(Components.Wrapper, null,
        React.createElement(Components.ErrorMessage, { message: "Self-Sign-Up is not supported." })));
}
exports.AuthConfirmSignUp = AuthConfirmSignUp;
//# sourceMappingURL=AuthConfirmSignUp.js.map